import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {StateService} from '../state.service';
import {Injectable} from '@angular/core';
import {isNullOrUndefined} from 'util';

@Injectable()
export class HasChosenPurchaseGuard implements CanActivate {
  constructor(private router: Router, private state: StateService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // if (isNullOrUndefined(this.state.snapshot.purchase.chosen)) {
    //   this.router.navigate(['purchase', 'choose']);
    //
    //   return false;
    // }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/state/guard/has-chosen-purchase-guard.ts